import i18n, { changeLanguage, use } from 'i18next'
import { initReactI18next } from 'react-i18next'

import { getI18nextInitParams } from '../common/i18n-utils.js'
import { formatLocaleForI18N } from './utils/utils.js'

const localStorageLocaleKey = 'i18nextLng'

// eslint-disable-next-line react-hooks/rules-of-hooks
void use(initReactI18next).init({
    ...getI18nextInitParams(true),
    fallbackLng: localStorage.getItem(localStorageLocaleKey) || 'en',
    lng: localStorage.getItem(localStorageLocaleKey) || undefined,
})

export const changeLocale = async (locale: string): Promise<void> => {
    const formattedLocale = formatLocaleForI18N(locale)

    localStorage.setItem(localStorageLocaleKey, formattedLocale)
    await changeLanguage(formattedLocale)
        .then(() => {
            document.documentElement.lang = locale
        })
        .catch(console.error)
}

export default i18n
